import { CheckoutCopyright } from "components/UI/atoms";
import {
  CheckoutCouponDiscount,
  CheckoutSubmit,
  CheckoutSummaryOrder,
  CheckoutSummaryTable
} from "components/UI/molecules";
import { INTERNAL_PATHS } from "routes/paths";
import { useCheckoutContext } from "context/checkout-context";
import { useNavigate } from "hooks/useCustomNavigation";
import "./index.scss";

export const CheckoutSummary = () => {
  const { checkoutData, handleCheckout: submitOrder } = useCheckoutContext();
  const navigate = useNavigate();

  return (
    <div className="checkout-summary">
      <div className="header-summary">
        <h2 className="summary-title">Order Summary</h2>
        <button
          onClick={() => navigate(INTERNAL_PATHS.CART)}
          className="edit-cart"
        >
          Edit
        </button>
      </div>

      <CheckoutSummaryTable cards={checkoutData.cards} />
      <CheckoutCouponDiscount />
      <CheckoutSummaryOrder
        order={{
          total: checkoutData.total,
          subTotal: checkoutData.subtotal,
          totalSavings: checkoutData.total_savings
        }}
      />
      <CheckoutSubmit handleSubmit={submitOrder} />
      <CheckoutCopyright customClassName="checkout-copyright-mobile" />
    </div>
  );
};
